module.exports = __webpack_public_path__ + "img/home.ce2ff00d.png";